exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spec-table[data-v-9575e0aa]{width:100%;font-size:12px}.spec-table td[data-v-9575e0aa]{padding:3px}.list p[data-v-9575e0aa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0}.list[data-v-9575e0aa]:nth-child(2n){background:#f7f7f7}\n", ""]);

// exports
